/** Enumerations shared by DB (enum types), API validation and UI labels. Keep in sync with migrations. */

export const USER_ROLES = ['admin', 'manager', 'sales', 'viewer'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const LIFECYCLE_STAGES = ['lead', 'customer', 'archived'] as const;
export type LifecycleStage = (typeof LIFECYCLE_STAGES)[number];

export const LEAD_SOURCES = [
  'website', 'meta', 'google', 'tiktok', 'instagram', 'whatsapp', 'phone', 'referral', 'exhibition', 'manual', 'other',
] as const;
export type LeadSource = (typeof LEAD_SOURCES)[number];

export const PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const;
export type Priority = (typeof PRIORITIES)[number];

export const CONTACT_ROLES = ['owner', 'purchasing', 'finance', 'operations', 'branch_manager', 'chef', 'barista', 'other'] as const;
export type ContactRole = (typeof CONTACT_ROLES)[number];

export const ACTIVITY_TYPES = [
  'lead_created', 'website_enquiry', 'meta_lead', 'tiktok_lead', 'call', 'whatsapp', 'email', 'note', 'task', 'meeting',
  'sample', 'quote', 'order', 'invoice', 'payment', 'stage_change', 'system',
] as const;
export type ActivityType = (typeof ACTIVITY_TYPES)[number];

/** Activity types a user can log manually from the UI. */
export const LOGGABLE_ACTIVITY_TYPES = ['call', 'whatsapp', 'email', 'meeting', 'note'] as const;
export type LoggableActivityType = (typeof LOGGABLE_ACTIVITY_TYPES)[number];
/** Types that count as "contact made" and update last_contact_at. */
export const CONTACT_ACTIVITY_TYPES: readonly ActivityType[] = ['call', 'whatsapp', 'email', 'meeting'];

export const DIRECTIONS = ['inbound', 'outbound'] as const;
export type Direction = (typeof DIRECTIONS)[number];

export const CALL_OUTCOMES = ['answered', 'no_answer', 'busy', 'left_message', 'wrong_number'] as const;
export type CallOutcome = (typeof CALL_OUTCOMES)[number];

export const TASK_KINDS = ['followup', 'task', 'meeting', 'call'] as const;
export type TaskKind = (typeof TASK_KINDS)[number];

export const TASK_STATUSES = ['open', 'done', 'cancelled'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const STAGE_KINDS = ['open', 'won', 'lost'] as const;
export type StageKind = (typeof STAGE_KINDS)[number];

export const SUBMISSION_STATUSES = ['received', 'created', 'attached', 'pending_review', 'rejected', 'error'] as const;
export type SubmissionStatus = (typeof SUBMISSION_STATUSES)[number];

export const NOTIFICATION_TYPES = [
  'new_lead', 'website_lead', 'duplicate_suspected', 'enquiry_attached', 'followup_today', 'followup_overdue', 'meeting',
  'quote_followup', 'reorder_due', 'invoice_overdue', 'low_stock', 'assigned', 'system',
] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];
